import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuComponent } from './menu.component';
import { PermissionModule } from '@shared/permission/permission.module';
import { SharedModule } from '@shared/shared.module';

@NgModule({
    imports: [CommonModule, RouterModule, TranslateModule, PermissionModule, SharedModule, MenuComponent],
    exports: [MenuComponent]
})
export class MenuModule {}
